// Client-safe locale metadata (NO server-only import). The language
// switcher is a client component, so the human labels and route map
// live here rather than in dictionaries.ts.

export type PublicLocale = 'de' | 'en' | 'tr'

export const PUBLIC_LOCALES: PublicLocale[] = ['de', 'en', 'tr']

export const LOCALE_LABEL: Record<PublicLocale, string> = {
  de: 'Deutsch',
  en: 'English',
  tr: 'Türkçe',
}

export const LOCALE_SHORT: Record<PublicLocale, string> = {
  de: 'DE',
  en: 'EN',
  tr: 'TR',
}

// Homepage route for each locale.
export const LOCALE_HOME: Record<PublicLocale, string> = {
  de: '/',
  en: '/en',
  tr: '/tr',
}
